import React, { useEffect, useState } from 'react';
import { Link } from 'react-router-dom';
import MyApiClient from '../../../api-client/MyApiClient';

/*
 * "Dati intestatario" nel box a destra di dettaglio ordine e dettaglio documento: la persona
 * dell'account che ha acquistato (nome con link alla scheda, junior) con indirizzo e
 * contatti letti dal suo profilo privato, come fa la scheda del player. Solo testo, niente icone.
 * I "Dati fatturazione" (il destinatario del documento) stanno sotto, nella pagina.
 */

export const DatiIntestatario = ({ playerId, playerName, juniorName }) => {
	const [dati, setDati] = useState(null);

	useEffect(() => {
		let annullato = false;
		setDati(null);
		if (!playerId) return undefined;
		let token = null;
		try {
			token = JSON.parse(sessionStorage.getItem('userDetails') || '{}').idToken;
		} catch (e) {
			token = null;
		}
		if (!token) return undefined;
		new MyApiClient()
			.getPrivateProfile(token, playerId)
			.then((res) => {
				if (!annullato && res && !res.error) setDati(res.idsPlay || res.idsGuru || null);
			})
			.catch(() => {});
		return () => {
			annullato = true;
		};
	}, [playerId]);

	const nome = playerId
		? <Link to={`/struttura/clienti/player_profile/${playerId}`}>{playerName || '-'}</Link>
		: playerName;
	const righe = [
		['Nome', nome],
		['Junior', juniorName],
		['Email', dati?.email],
		['Telefono', dati?.phoneNumber],
		['Cod. fiscale', dati?.taxCode],
		['Indirizzo', dati?.address?.streetAddress],
		['CAP', dati?.address?.postalCode],
		['Città', dati?.address?.locality],
		['Provincia', dati?.address?.province],
		['Nazione', dati?.address?.country],
	].filter(([, valore]) => valore);

	return (
		<>
			<h5 className="sid-order-card__title">Dati intestatario</h5>
			{righe.length > 0 && (
				<dl className="sid-recipient__list">
					{righe.map(([etichetta, valore]) => (
						<React.Fragment key={etichetta}>
							<dt>{etichetta}</dt>
							<dd>{valore}</dd>
						</React.Fragment>
					))}
				</dl>
			)}
		</>
	);
};

export default DatiIntestatario;
